import { apiBase } from "./base";

const apiSom = {
	client: apiBase.get_client(),
	url: "/som/",

	getItems() {
		return this.client.get(this.url + "item/", apiBase.get_headers());
	},

	getItem({ itemId }) {
		return this.client.get(this.url + "item/" + itemId + "/", apiBase.get_headers());
	},

	createItem({ body }) {
		return this.client.post(this.url + "item/", body, apiBase.get_headers());
	},

	deleteItem({ itemId }) {
		return this.client.delete(this.url + "item/" + itemId + "/", apiBase.get_headers());
	},

	editItem({ itemId, body }) {
		return this.client.patch(this.url + "item/" + itemId + "/", body, apiBase.get_headers());
	},

	editItemCharValueOrder({ itemId, body }) {
		return this.client.post(this.url + "item/" + itemId + "/char_value_order/", body, apiBase.get_headers());
	},

	getBooks() {
		return this.client.get(this.url + "books/", apiBase.get_headers());
	},

	getClsTree({ clsId }) {
		return this.client.get(this.url + "cls_tree/" + clsId + "/", apiBase.get_headers());
	},

	searchClsTree({ clsId, searchText }) {
		return this.client.get(this.url + "cls_tree/" + clsId + "/search/" + searchText + "/", apiBase.get_headers());
	},

	getDb({ body }) {
		return this.client.post(this.url + "db/", body, apiBase.get_headers());
	},

	getDbStats({ body }) {
		return this.client.post(this.url + "db/stats/", body, apiBase.get_headers());
	},

	uploadJustFile({ file, somId, offerId }) {
		const formData = new FormData();
		formData.append("file", file);
		formData.append("som_item_id", somId);
		formData.append("som_item_offer_id", offerId);

		return this.client.post(this.url + "justs/", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: localStorage.getItem("accessToken"),
				"Auth-Uuid": localStorage.getItem("authUuid"),
			},
		});
	},

	getJustFile({ justId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "justs/" + justId + "/", headers);
	},

	deleteJustFile({ justId }) {
		return this.client.delete(this.url + "justs/" + justId + "/", apiBase.get_headers());
	},

	setPriceOfferStatus({ body }) {
		return this.client.post(this.url + "price_offer/status/", body, apiBase.get_headers());
	},

	editOfferProvider({ body }) {
		return this.client.patch(this.url + "price_offer/provider/", body, apiBase.get_headers());
	},

	getSomOfferMonitoring({ somOfferId }) {
		return this.client.get(this.url + "monitoring/" + somOfferId + "/", apiBase.get_headers());
	},

	postSomOfferMonitoring({ body }) {
		return this.client.post(this.url + "monitoring/", body, apiBase.get_headers());
	},

	postSomOfferMonitoringWithJust({ files, body }) {
		let i = 0;
		const formData = new FormData();
		for (let file of files) {
			formData.append(`file_${i}`, file);
			i++;
		}

		formData.append("json", JSON.stringify(body));
		return this.client.post(this.url + "monitoring/", formData, {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: localStorage.getItem("accessToken"),
				"Auth-Uuid": localStorage.getItem("authUuid"),
			},
		});
	},

	getMonitoringJustFile({ justId }) {
		const headers = apiBase.get_headers();
		headers["responseType"] = "blob";
		return this.client.get(this.url + "monitoring/justs/" + justId + "/", headers);
	},
};

export default apiSom;
